import React, { useEffect, useState, } from 'react';
import { Link, useHistory, useParams, } from 'react-router-dom';
import $ from 'jquery';
import 'react-tempusdominus-bootstrap';
import axios from 'axios';

import useAuth from '../../controllers/users/useAuth';
import {
    dataTableLanguaje, buttonProcessGet, responseGet, globalSettings, styles, sendMessageCloseCurrentWindowAsync, awaitDelay, dateTimeFormatGlobalSet, processEvaluateGet, checkIfUserIsMaster,
    languageObjGet, isUndNullEmp, LoadingSection,
} from '../../helpers/settings';

import BuildingContracts from './BuildingContracts';

import Menu from '../main/Menu';
import ElevatorAddEditDetails from '../elevators/ElevatorAddEditDetails';
import InventoryAddEditDetails from '../inventories/InventoryAddEditDetails';
import CommonAreaAddEditDetails from '../commonAreas/CommonAreaAddEditDetails';
import { commonAreaModelGet } from '../../models/commonArea/commonArea';
import { userByIdGetAsync, } from '../../controllers/users/users';
//import CssfxLoading from '../main/CssfxLoading';
import { validationCoinGetAsync } from '../../helpers/validations';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { buildingModelGet } from '../../models/buildings/building';
import { elevatorModelGet } from '../../models/elevators/elevator';
import { inventoryModelGet } from '../../models/inventories/inventory';

const currentMethod = 'BuildingDetails';

const { icons, labels, messages, } = globalSettings;

export default function BuildingDetails({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    const { id, } = useParams();
    let buildingTwo = buildingModelGet({});
    let result;
    let dataObj = {};
    let headerObj = {};
    //let swalProperty = {};
    const auth = useAuth();
    const history = useHistory();
    const userRole = checkIfUserIsMaster({ email: auth?.user?.email || '', subMethod: currentMethod, languageId: languageObj?.id, })?.result;
    //const buildingContractDateId = 'buildingContractDate';
    const [processValues, setProcessValues] = useState({
        auth: {},
        dtId: '',
        rowIndex: 0,
        showModal: false,
        setShowModal: null,
        type: 0,
        user: {},
    });
    //const [showLoading, setShowLoading] = useState(true);
    //const [showData, setShowData] = useState(true);
    const [showLoading, setShowLoading] = useState({ building: true, floorsParkingStalls: true, elevators: true, inventory: true, commonArea: true, settings: true, });
    //#endregion variables

    //#region contracts
    const contractsDtId = 'contractsDt';
    const [contracts, setContracts] = useState([]);
    const [contractsDt, setContractsDt] = useState([]);
    const [contractShowModal, setContractShowModal] = useState(false);
    //#endregion contracts

    //#region elevators
    let elevators = [];
    const [elevator, setElevator] = useState({});
    const dtElevatorsId = 'dtElevators';
    const [showModalElevator, setShowModalElevator] = useState(false);
    //#endregion elevators

    //#region Inventories
    let inventories = [];
    const [inventory, setInventory] = useState({});
    const dtInventoriesId = 'dtInventory';
    const [showModalInventory, setShowModalInventory] = useState(false);
    //#endregion Inventories

    //#region variables
    const [building, setBuilding] = useState(buildingModelGet({}));
    const [coins, setCoins] = useState([]);
    const [totalApartments, setTotalApartments] = useState(0);
    //#endregion variables

    //#region reserve common area
    let commonAreas = [];
    const dtCommonAreasId = 'dtCommonAreas';
    const [commonAreaShowModal, setCommonAreaShowModal] = useState(false);
    const [commonArea, setCommonArea] = useState({});
    //#endregion reserve common area

    //#region others
    const controls = {
        buttons: {
            contract: {
                className: 'btn btn-outline-info',
                id: 'btnContract',
            },
            back: {
                className: 'btn btn-outline-success mx-1',
                id: 'btnBack',
            },
        },
        checkBox: {
            // remenberMe: {
            //     attributes: {
            //     },
            //     id: 'chkRemenberMe',
            // },
        },
        dataTables: {
            elevators: {
                inputs: {
                    search: {
                        id: `${dtElevatorsId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtElevatorsId}_length select`,
                        className: '',
                    },
                },
            },
            inventories: {
                inputs: {
                    search: {
                        id: `${dtInventoriesId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtInventoriesId}_length select`,
                        className: '',
                    },
                },
            },
            commonAreas: {
                inputs: {
                    search: {
                        id: `${dtCommonAreasId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtCommonAreasId}_length select`,
                        className: '',
                    },
                },
            },
        },
        icons: {
            contract: {
                id: 'iconContract',
                className: icons?.fileInvoice,
            },
            back: {
                id: 'iconBack',
                className: icons?.arrowCircleLeft,
            },
        },
        inputs: {
            // email: {
            //     id: 'inputEmail',
            // },
            // password: {
            //     id: 'inputPassword',
            // },
        },
        spinners: {
            contract: {
                id: 'spContract',
                className: '',
            },
            back: {
                id: 'spBack',
                className: '',
            },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion others

    //#region building (methods)
    //#region old code
    // const dateInControlSetAsync = (date, buildingContractDate) => {
    //     let response = responseGet();
    //     try {
    //         let localDate = '';
    //         //const localDateFormat = 'd/m/y';
    //         const localDateFormat = globalSettings?.react?.tempusDominus?.format?.date?.dmy;
    //         //const localDateFormatTwo = 'DD/MM/YYYY'
    //         const localDateFormatTwo = globalSettings?.react?.tempusDominus?.format?.date?.DDMMYYYY;
    //         //const localTimeFormatTwo = 'hh:mm A'
    //         const localTimeFormatTwo = globalSettings?.react?.tempusDominus?.formatTimehhmmA;

    //         if (!isUndefined(buildingContractDate) && !isNull(buildingContractDate)) {
    //             localDate = dateTimeFormatGlobalSet(buildingContractDate, localDateFormat, 12, false).result;
    //         } else if (!isUndefined(date) && !isNull(date)) {
    //             localDate = dateTimeFormatGlobalSet(date, localDateFormat, 12, false).result;
    //         }

    //         $.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
    //             icons: globalSettings?.react?.tempusDominus?.icons,
    //             buttons: globalSettings?.react?.tempusDominus?.buttons,
    //             tooltips: globalSettings?.react?.tempusDominus?.tooltips,
    //             locale: 'es',
    //         });

    //         $(`#${buildingContractDateId}`)?.datetimepicker({
    //             date: moment(`${localDate}`, `${localDateFormatTwo} ${localTimeFormatTwo}`),
    //             default: false,
    //             format: `${localDateFormatTwo} ${localTimeFormatTwo}`,
    //         });
    //     } catch (ex) {
    //         response.isSuccess = false;
    //         response.msgType = -1;
    //         response.msgText = `Method: dateInControlSetAsync<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //     }
    //     return response;
    // }
    //#endregion old code

    const backToGoAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'backToGoAsync';
        let response = responseGet();
        try {
            e?.preventDefault();
            controlsStatusSet({ processType: 2, subMethod: currentMethod, });
            await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
            history.push(globalSettings?.app?.backend?.urlBuildings);
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }

    const calculateTotalApartments = ({ apartmentsPerTopLevel = 0, floors = 0, apartmentsPerFloor = 0, apartmentsPerLowLevel = 0, subMethod = '', }) => {
        const currentMethod = 'calculateTotalApartments';
        let response = responseGet();
        try {
            //#region process
            setTotalApartments(apartmentsPerTopLevel + (floors * apartmentsPerFloor) + apartmentsPerLowLevel);
            //#endregion process
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const contractAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'contractAsync';
        let response = responseGet();
        try {
            //#region variables
            let contractsLocal = [];
            let contractsDtLocal = [];
            //#endregion variables

            //#region initialize
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }
            //#endregion initialize

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region data get (buildingContracts)
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                conditionals: [
                    { field: globalSettings?.collections?.properties?.buildingId, operator: globalSettings?.react?.firebase?.operators?.equalTo, value: `${building.id}`, },
                ],
                ordersBy: [
                    { field: globalSettings?.collections?.properties?.dateStart, value: 'desc', },
                ],
                buildingId: building.id,
                languageId: languageObj?.id,
                url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlBuildingContracts}/`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            contractsLocal = response?.result;
            setContracts(contractsLocal);
            //#endregion data get (buildingContracts)

            //#region set contractsDt
            if (!isUndNullEmp({ data: contractsLocal, subMethod: currentMethod, })?.result && contractsLocal?.length > 0) {
                contractsLocal?.forEach((detail) => {
                    contractsDtLocal?.push([
                        dateTimeFormatGlobalSet({
                            date: detail?.dateStart,
                            type: globalSettings?.react?.tempusDominus?.format?.date?.ymdTwo,
                            format: 24,
                            addTime: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        }).result,
                        detail?.subContractId,
                        dateTimeFormatGlobalSet({
                            date: detail?.dateStart,
                            type: languageObj?.format?.date?.f1,
                            format: 0,
                            addTime: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        })?.result,
                        dateTimeFormatGlobalSet({
                            date: detail?.dateEnd,
                            type: languageObj?.format?.date?.f1,
                            format: 0,
                            addTime: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        })?.result,
                        buttonProcessGet({
                            id: detail?.id,
                            description: detail?.subContractId,
                            showDetails: true,
                            labelDetails: labels?.detail?.[languageObj?.id],
                            enabledDetails: true,
                            showEdit: true,
                            labelEdit: labels?.edit?.[languageObj?.id],
                            enabledEdit: processEvaluateGet({
                                object: detail,
                                property: labels?.process?.en?.toLowerCase(),
                                process: labels?.edit?.en?.toLowerCase(),
                                subMethod: currentMethod,
                            })?.result,
                            showDelete: true,
                            labelDelete: labels?.delete?.[languageObj?.id],
                            enabledDelete: processEvaluateGet({
                                object: detail,
                                property: labels?.process?.en?.toLowerCase(),
                                process: labels?.delete?.en?.toLowerCase(),
                                subMethod: currentMethod,
                            })?.result,
                            processButtons: [],
                            subMethod: currentMethod,
                        })?.result,
                    ])
                });
            }

            setContractsDt(contractsDtLocal);
            //#endregion set contractsDt

            setContractShowModal(true);
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
        return response;
    }
    //#endregion building (methods)

    //#region elevators (methods)
    const dataTableElevatorsSet = ({ subMethod = '', }) => {
        const currentMethod = 'dataTableElevatorsSet';
        let response = responseGet();
        try {
            //dtElevators = $(`#${dtElevatorsId}`)?.DataTable({
            $(`#${dtElevatorsId}`)?.DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.description?.[languageObj?.id], width: '55%', },
                    { title: labels?.type?.[languageObj?.id], width: '10%', },
                    { title: labels?.brand?.[languageObj?.id], width: '15%', },
                    { title: labels?.model?.[languageObj?.id], width: '15%', },
                    { title: labels?.process?.[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                responsive: true,
                lengthChange: true,
                autoWidth: false,
            });
            //.buttons().container().appendTo(`#${dtElevatorsId}_wrapper .col-md-6:eq(0)`);
            //queryCodeSet();
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const elevatorGetType = ({ data = elevatorModelGet({}), subMethod = '', }) => {
        const currentMethod = 'elevatorGetType'
        let response = responseGet();
        try {
            if (data?.both) {
                response.result = labels?.both?.[languageObj?.id];
            } else if (data?.even) {
                response.result = labels?.even?.[languageObj?.id];
            } else if (data.odd) {
                response.result = labels?.odd?.[languageObj?.id];
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            response.result = `${currentMethod} - error`;
            console?.error(response);
        }
        return response;
    }

    const elevatorEditDetailsGetAsync = async ({ id_ = '', description = '', rowIndex = 0, processType = 0, subMethod = '', }) => {
        const currentMethod = 'elevatorEditDetailsGetAsync';
        let response = responseGet();
        try {
            //#region variables
            let userLocal = {};
            let elevatorLocal = elevatorModelGet({});
            //#endregion variables

            setShowLoading({ building: false, floorsParkingStalls: false, elevators: true, inventory: false, commonArea: false, settings: false, });

            //#region set initial values
            if (isUndNullEmp({ data: buildingTwo?.elevators, subMethod: currentMethod, })?.result) {
                setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: 1,
                    msgText: messages?.youMustCreateLeastOneElevator?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            elevatorLocal = buildingTwo?.elevators?.find(({ id }) => id === id_);

            if (isUndNullEmp({ data: elevatorLocal, subMethod: currentMethod, })?.result) {
                setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
                response.msgType = 1;
                response.msgText = `${messages?.theRecordCannotBeLocated?.[languageObj?.id]}:<br/>`;
                response.msgText += `<b>${description}</b><br/>`;
                response.msgText += `${messages?.pleaseTryAgain?.[languageObj?.id]}`;
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            //#region user get data
            if (!isUndNullEmp({ data: elevatorLocal?.userId, subMethod: currentMethod, })?.result) {
                response = await userByIdGetAsync({
                    id: elevatorLocal?.userId,
                    auth: auth,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }

                //setUser(!isUndefined(response.result) && !isNull(response.result) ? response.result : {});
                userLocal = !isUndNullEmp({ data: response?.result, subMethod: currentMethod, })?.result ? response?.result : {};
            }
            //#endregion get user data

            setElevator(elevatorLocal);

            //#region set process values
            setProcessValues({
                auth: auth,
                dtId: dtElevatorsId,
                rowIndex: rowIndex,
                showModal: false,
                setShowModal: null,
                type: processType,
                user: userLocal,
            });
            //#endregion set process values

            //#endregion set initial values
            setShowModalElevator(true);

            setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
        } catch (ex) {
            setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }
    //#endregion elevators (methods)

    //#region inventory (methods)
    const dataTableInventorySet = ({ subMethod = '', }) => {
        const currentMethod = 'dataTableInventorySet';
        let response = responseGet();
        try {
            //dtInvntories = $(`#${dtInventoriesId}`)?.DataTable({
            $(`#${dtInventoriesId}`)?.DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.description?.[languageObj?.id], width: '55%', },
                    { title: labels?.type?.[languageObj?.id], width: '10%', },
                    { title: labels?.brand?.[languageObj?.id], width: '15%', },
                    { title: labels?.model?.[languageObj?.id], width: '15%', },
                    { title: labels?.process?.[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                responsive: true,
                lengthChange: true,
                autoWidth: false,
            });
            //.buttons().container().appendTo(`#${dtInventoriesId}_wrapper .col-md-6:eq(0)`);
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const inventoryEditDetailsGetAsync = async ({ id_ = '', description = '', rowIndex = 0, processType = 0, subMethod = '', }) => {
        const currentMethod = 'inventoryEditDetailsGetAsync';
        let response = responseGet();
        try {
            //#region variables
            let userLocal = {};
            let inventoryLocal = inventoryModelGet({});
            //#endregion variables

            setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: true, commonArea: false, settings: false, });

            //#region set initial data
            if (isUndNullEmp({ data: buildingTwo?.inventories, subMethod: currentMethod, })?.result) {
                setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: 1,
                    msgText: messages?.youMustCreateLeastOneInventory?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            inventoryLocal = buildingTwo?.inventories?.find(({ id }) => id === id_);

            if (isUndNullEmp({ data: inventoryLocal, subMethod: currentMethod, })?.result) {
                setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
                response.msgType = 1;
                response.msgText = `${messages?.theRecordCannotBeLocated?.[languageObj?.id]}:<br/>`;
                response.msgText += `<b>${description}</b><br/>`;
                response.msgText += `${messages?.pleaseTryAgain?.[languageObj?.id]}`;
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            //#region user get data
            if (!isUndNullEmp({ data: inventoryLocal?.userId, subMethod: currentMethod, })?.result) {
                response = await userByIdGetAsync({
                    id: inventoryLocal?.userId,
                    auth: auth,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }

                //setUser(!isUndefined(response.result) && !isNull(response.result) ? response.result : {});
                userLocal = !isUndNullEmp({ data: response?.result, subMethod: currentMethod, })?.result ? response?.result : {};
            }
            //#endregion get user data

            setInventory(inventoryLocal);

            //#region set process values
            setProcessValues({
                auth: auth,
                dtId: dtInventoriesId,
                rowIndex: rowIndex,
                showModal: false,
                setShowModal: null,
                type: processType,
                user: userLocal,
            });
            //#endregion set process values

            //#endregion set initial data
            setShowModalInventory(true);
            setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
        } catch (ex) {
            setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }
    //#endregion inventory (methods)

    //#region Common areas (methods)
    const dataTableCommonAreasSet = ({ subMethod = '', }) => {
        const currentMethod = 'dataTableCommonAreasSet';
        let response = responseGet();
        try {
            //dtInvntories = $(`#${dtInventoriesId}`)?.DataTable({
            $(`#${dtCommonAreasId}`)?.DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.commonArea?.[languageObj?.id], width: '95%', },
                    { title: labels?.process?.[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                responsive: true,
                lengthChange: true,
                autoWidth: false,
            });
            //.buttons().container().appendTo(`#${dtInventoriesId}_wrapper .col-md-6:eq(0)`);
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const commonAreaAddEditDeleteAsync = async ({ id_ = '', description = '', rowIndex = 0, processType = 0, subMethod = '', }) => {
        const currentMethod = 'commonAreaAddEditDeleteAsync';
        let response = responseGet();
        try {
            //#region variables
            let userLocal = {};
            const modalShowLocal = processType > -1;
            let commonAreaLocal = commonAreaModelGet({});
            //let localCommonAreasBefore = [];
            //#endregion variables

            setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: true, settings: false, });

            //#region check process
            if (processType === -1) {
                //#region delete
                //#region show message
                //#region old code
                // swalProperty = {
                //     icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
                //     title: messages?.areYouSureDeleteThis?.[languageObj?.id],
                //     html: `${labels?.commonArea?.[languageObj?.id]}: <b>${description}</b><br/>${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
                //     timer: null,
                //     confirmButtonColor: globalSettings?.colors?.warningColorExp,
                //     confirmButtonText: labels?.yes?.[languageObj?.id],
                //     showCancelButton: true,
                //     cancelButtonColor: globalSettings?.colors?.successColorExp,
                //     cancelButtonText: labels?.no?.[languageObj?.id],
                //     didOpen: () => {
                //         Swal.hideLoading();
                //     },
                // };

                // const { isConfirmed, } = await Swal.fire(swalProperty);
                //#endregion old code
                //#endregion show message

                //#region delete data
                //#region old code
                // if (isConfirmed) {
                //     sendMessage(2, messages?.processing?.[languageObj?.id], globalSettings?.timers?.thirtySeconds, false, true, null, '');

                //     if (!isNull(building)) {
                //         //building.commonAreas = building.commonAreas.filter(({ id }) => id !== commonAreaId);
                //         building.commonAreas = buildingTwo.commonAreas.filter(({ id }) => id !== id_);
                //     }
                //     localCommonAreasBefore = buildingTwo.commonAreas;

                //     //#region Common area delete

                //     localCommonArea = buildingTwo.commonAreas.filter(({ id, }) => id === id_);
                //     localCommonArea = isArray(localCommonArea) ? localCommonArea[0] : localCommonArea;

                //     //#endregion Common area delete
                //     buildingTwo.commonAreas = buildingTwo.commonAreas.filter(({ id }) => id !== id_);

                //     headerObj = {
                //         headers: {
                //             authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                //         },
                //     };
                //     dataObj = {
                //         commonAreas: buildingTwo.commonAreas,
                //         commonArea: localCommonArea,
                //         isDelete: true,
                //     };
                //     //result = await axios?.post(`${globalSettings?.app?.backend?.urlDev}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlCommonAreas}/${id}`, localData, headerObj);
                //     result = await axios?.post(`${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlCommonAreas}/${id}`, dataObj, headerObj);
                //     response = result.data;

                //     if (!response?.isSuccess || response?.isWarning) {
                //         buildingTwo.commonAreas = localCommonAreasBefore;
                //         //building.commonAreas = localCommonAreas;
                //         await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
                //         return;
                //     }

                //     $(`#${dtCommonAreasId}`)?.DataTable()?.row(rowIndex)?.remove()?.draw(true);
                //     sendMessage(0, messages?.processesCompletedSuccessfully?.[languageObj?.id], 0, true, false, null, '');
                // }
                //#endregion old code
                //#endregion delete data

                //return response;
                //#endregion delete
            } else if (processType === 0) {
                //#region New
                //#region old code
                //setCommonArea(commonAreaModelGet(uuidv4(), auth?.user?.uid,));
                //#endregion old code
                //#endregion New
            } else if (processType > 0) {
                //#region Edit / detail
                if (isUndNullEmp({ data: buildingTwo?.commonAreas, subMethod: currentMethod, })?.result) {
                    setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: 1,
                        msgText: messages?.youMustCreateLeastOneCommonArea?.[languageObj?.id],
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }

                commonAreaLocal = buildingTwo?.commonAreas?.find(({ id }) => id === id_);

                if (isUndNullEmp({ data: commonAreaLocal, subMethod: currentMethod, })?.result) {
                    setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
                    response.msgType = 1;
                    response.msgText = `${messages?.theRecordCannotBeLocated?.[languageObj?.id]}:<br/>`;
                    response.msgText += `<b>${description}</b><br/>`;
                    response.msgText += `${messages?.pleaseTryAgain?.[languageObj?.id]}`;
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }

                setCommonArea(commonAreaLocal);

                //#region user get data
                if (!isUndNullEmp({ data: commonAreaLocal?.userId, subMethod: currentMethod, })?.result) {
                    response = await userByIdGetAsync({
                        id: commonAreaLocal?.userId,
                        auth: auth,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });

                    if (!response?.isSuccess || response?.isWarning) {
                        setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }

                    //setUser(!isUndefined(response.result) && !isNull(response.result) ? response.result : {});
                    userLocal = !isUndNullEmp({ data: response?.result, subMethod: currentMethod, })?.result ? response?.result : {};
                }
                //#endregion get user data
                //#endregion Edit /detail
            }

            //setCommonAreaShowModal(localShowModal);
            //#endregion check process

            //#region set process values
            setProcessValues({
                auth: auth,
                dtId: dtCommonAreasId,
                rowIndex: rowIndex,
                showModal: modalShowLocal,
                setShowModal: setCommonAreaShowModal,
                type: processType,
                user: userLocal,
            });
            //#endregion set process values

            setCommonAreaShowModal(modalShowLocal);
            setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
        } catch (ex) {
            setCommonAreaShowModal(false);
            setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }
    //#endregion Common areas (methods)

    //#region methods (others)
    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            //setShowLoading(true);
            //setShowData(false);

            //#region variables
            let coinsLocal = [];
            let buildingLocal = buildingModelGet({});
            //#endregion variables

            //#region initialize
            elevators = [];
            inventories = [];
            commonAreas = [];
            //#endregion initialize

            //#region dataTables set
            response = dataTablesSet({
                dtElevators: true,
                dtInventories: true,
                dtCommonAreas: true,
                queryCodeSet_: true,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                //setShowLoading(false);
                //setShowData(false);
                setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion dataTables set

            //#region check role user
            //#region old code
            // if (userRole === '') {
            //     //history.push('/');
            //     //setShowLoading(false);
            //     //setShowData(false);
            //     await sendMessageCloseCurrentWindowAsync(1, messages?.youDoNotHaveSufficientPrivilegesToRunThisProcess?.[languageObj?.id], false, globalSettings?.app?.backend?.urlHome, auth, false);
            // }
            //#endregion old code
            //#endregion check role user

            //#region data get
            //#region coins get
            //#region old code
            // headerObj = {
            //     headers: {
            //         authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
            //     },
            // };

            // localData = {
            //     conditionals: [
            //         { field: globalSettings?.collections?.properties?.buildingId, operator: globalSettings?.react?.firebase?.operators?.equalTo, value: `${id}`, },
            //     ],
            //     ordersBy: [
            //         { field: globalSettings?.collections?.properties?.description, value: `asc`, },
            //     ],
            //     buildingId: id,
            // };

            // //result = await axios?.post(`${globalSettings?.app?.backend?.urlDev}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlCoins}/`, localData, headerObj);
            // result = await axios?.post(`${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlCoins}/`, localData, headerObj);
            // response = result.data;

            // if (!response?.isSuccess || response?.isWarning) {
            //     //setShowLoading(false);
            //     //setShowData(false);
            //     await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
            //     return;
            // }

            // if (isUndefined(response.result) || isNull(response.result) || response.result.length <= 0) {
            //     //setShowLoading(false);
            //     //setShowData(false);
            //     response.msgText = `${messages?.youMustCreateLeastOneCoin?.[languageObj?.id]}<br/>`;
            //     response.msgText += `${messages?.goTo?.[languageObj?.id]}: <i class='${icons?.coins}'></i> `;
            //     response.msgText += `<a href='${globalSettings?.app?.backend?.urlCoins}'>${labels?.coins?.[languageObj?.id]}</a>`;
            //     await sendMessageCloseCurrentWindowAsync(response.msgType, response.msgText, false, globalSettings?.app?.backend?.urlBuildings, auth);
            //     return;
            // }
            // setCoins(response.result);
            //#endregion old code

            response = await validationCoinGetAsync({
                buildingId: id,
                limit: 0,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                //setShowLoading(false);
                //setShowData(false);
                setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            //setCoins(response?.result || []);
            coinsLocal = !isUndNullEmp({ data: response?.result, subMethod: currentMethod, })?.result ? response?.result : [];
            setCoins(coinsLocal);
            //#endregion coins get

            //#region building get
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    languageId: languageObj?.id,
                },
                url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlBuildings}/${id}`,
            };

            result = await axios?.get(
                headerObj?.url,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                //setShowLoading(false);
                //setShowData(false);
                setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            buildingLocal = response?.result;
            setBuilding(buildingLocal);
            buildingTwo = buildingLocal;
            //#region control data set

            //#region old code
            // response = dateInControlSetAsync(new Date(), localBuilding.contractDate);
            // if (!response?.isSuccess || response?.isWarning) {
            //     //setShowLoading(false);
            //     //setShowData(false);
            //     await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth);
            //     return;
            // }
            //#endregion old code

            //#endregion control data set

            //#region calculate total apartments
            response = calculateTotalApartments({
                apartmentsPerTopLevel: buildingLocal?.apartmentsPerTopLevel,
                floors: buildingLocal?.floors,
                apartmentsPerFloor: buildingLocal?.apartmentsPerFloor,
                apartmentsPerLowLevel: buildingLocal?.apartmentsPerLowLevel,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                //setShowLoading(false);
                //setShowData(false);
                setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion calculate total apartments

            //#region load elevators
            if (!isUndNullEmp({ data: buildingLocal?.elevators, subMethod: currentMethod, })?.result && buildingLocal?.elevators?.length > 0) {
                buildingLocal?.elevators?.map((detail) => (
                    elevators?.push([
                        detail?.description,
                        elevatorGetType({ data: detail, subMethod: currentMethod, })?.result,
                        detail?.brand,
                        detail?.model,
                        buttonProcessGet({
                            id: detail?.id,
                            description: detail?.description,
                            showDetails: true,
                            labelDetails: labels?.detail?.[languageObj?.id],
                            enabledDetails: true,
                            showEdit: false,
                            labelEdit: '',
                            enabledEdit: false,
                            showDelete: false,
                            labelDelete: '',
                            enabledDelete: false,
                            processButtons: [],
                            subMethod: currentMethod,
                        })?.result,
                    ])
                ));
            }
            //#endregion load elevators

            //#region load inventories
            if (!isUndNullEmp({ data: buildingLocal?.inventories, subMethod: currentMethod, })?.result && buildingLocal?.inventories?.length > 0) {
                buildingLocal?.inventories?.map((detail) => (
                    inventories?.push([
                        detail?.description,
                        detail?.type,
                        detail?.brand,
                        detail?.model,
                        buttonProcessGet({
                            id: detail?.id,
                            description: detail?.description,
                            showDetails: true,
                            labelDetails: labels?.detail?.[languageObj?.id],
                            enabledDetails: true,
                            showEdit: false,
                            labelEdit: '',
                            enabledEdit: false,
                            showDelete: false,
                            labelDelete: '',
                            enabledDelete: false,
                            processButtons: [],
                            subMethod: currentMethod,
                        })?.result,
                    ])
                ));
            }
            //#endregion load inventories

            //#region load common area
            if (!isUndNullEmp({ data: buildingLocal?.commonAreas, subMethod: currentMethod, })?.result && buildingLocal?.commonAreas?.length > 0) {
                buildingLocal?.commonAreas?.map((detail) => (
                    commonAreas?.push([
                        detail?.area,
                        buttonProcessGet({
                            id: detail?.id,
                            description: detail?.area,
                            showDetails: true,
                            labelDetails: labels?.detail?.[languageObj?.id],
                            enabledDetails: true,
                            showEdit: false,
                            labelEdit: '',
                            enabledEdit: false,
                            showDelete: false,
                            labelDelete: '',
                            enabledDelete: false,
                            processButtons: [],
                            subMethod: currentMethod,
                        })?.result,
                    ])
                ));
            }
            //#endregion load common area
            //#endregion building get
            //#endregion data get

            //setShowLoading(false);
            //setShowData(true);

            //#region dataTables set / Add data in DataTable
            //#region old code
            // response = dataTablesSet({
            //     dtElevators: true,
            //     dtInventories: true,
            //     dtCommonAreas: true,
            //     queryCodeSet: true,
            //     subMethod: currentMethod,
            // });

            // if (!response?.isSuccess || response?.isWarning) {
            //     //setShowLoading(false);
            //     //setShowData(false);
            //     await sendMessageCloseCurrentWindowAsync({
            //         msgType: response?.msgType,
            //         msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
            //         closeWindow: false,
            //         urlGoTo: response?.urlGoTo,
            //         auth: auth,
            //         isLogout: false,
            //         languageId: languageObj?.id,
            //         subMethod: currentMethod,
            //     });
            //     return;
            // }
            //#endregion old code

            $(`#${dtElevatorsId}`)?.DataTable()?.rows?.add(elevators)?.draw(true);
            $(`#${dtInventoriesId}`)?.DataTable()?.rows?.add(inventories)?.draw(true);
            $(`#${dtCommonAreasId}`)?.DataTable()?.rows?.add(commonAreas)?.draw(true);

            //#endregion dataTables set / Add data in DataTable

            setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
        } catch (ex) {
            //setShowLoading(false);
            //setShowData(false);
            setShowLoading({ building: false, floorsParkingStalls: false, elevators: false, inventory: false, commonArea: false, settings: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }

    const dataTablesSet = ({ dtElevators = false, dtInventories = false, dtCommonAreas = false, queryCodeSet_ = false, subMethod = '', }) => {
        const currentMethod = 'dataTablesSet';
        let response = responseGet();
        try {
            if (dtElevators) {
                response = dataTableElevatorsSet({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) {
                    return response;
                }
            }

            if (dtInventories) {
                response = dataTableInventorySet({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) {
                    return response;
                }
            }

            if (dtCommonAreas) {
                response = dataTableCommonAreasSet({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) {
                    return response;
                }
            }

            if (queryCodeSet_) {
                response = queryCodeSet({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) {
                    return response;
                }
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const queryCodeSet = ({ subMethod = '', }) => {
        const currentMethod = 'queryCodeSet';
        let response = responseGet();
        try {
            //#region variables
            let id = '';
            let method = '';
            let rowIndex = 0;
            let dtRowIndex = 0;
            let descriptionLocal = '';
            //#endregion variables

            //#region data table (Elevators)
            $(`#${dtElevatorsId} tbody`)?.on('click', 'tr', 'td', async function (e) {
                e?.preventDefault();
                rowIndex = $(`#${dtElevatorsId}`)?.DataTable()?.row(this)?.index();
                dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex;
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    method = e?.target?.attributes?.method?.value || '';
                    id = e?.target?.attributes?.id?.value || '';
                    descriptionLocal = e?.target?.attributes?.description?.value || '';
                    switch (method) {
                        case 'details':
                            elevatorEditDetailsGetAsync({ id_: id, description: descriptionLocal, rowIndex: dtRowIndex, processType: 2, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion data table (Elevators)

            //#region data table (iventories)
            $(`#${dtInventoriesId} tbody`)?.on('click', 'tr', 'td', async function (e) {
                e?.preventDefault();
                rowIndex = $(`#${dtInventoriesId}`)?.DataTable()?.row(this)?.index();
                dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex;
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    method = e?.target?.attributes?.method?.value || '';
                    id = e?.target?.attributes?.id?.value || '';
                    descriptionLocal = e?.target?.attributes?.description?.value || '';
                    switch (method) {
                        case 'details':
                            inventoryEditDetailsGetAsync({ id_: id, description: descriptionLocal, rowIndex: dtRowIndex, processType: 2, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion data table (iventories)

            //#region data table (common areas)
            $(`#${dtCommonAreasId} tbody`)?.on('click', 'tr', 'td', async function (e) {
                e?.preventDefault();
                rowIndex = $(`#${dtCommonAreasId}`)?.DataTable()?.row(this)?.index();
                dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex;
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    method = e?.target?.attributes?.method?.value || '';
                    id = e?.target?.attributes?.id?.value || '';
                    descriptionLocal = e?.target?.attributes?.description?.value || '';
                    switch (method) {
                        case 'details':
                            commonAreaAddEditDeleteAsync({ id_: id, description: descriptionLocal, rowIndex: dtRowIndex, processType: 2, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion data table (common areas)
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    $(`#${controls?.icons?.contract?.id}`)?.removeClass();
                    $(`#${controls?.buttons?.contract?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.contract?.id}`)?.removeClass();

                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.buttons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.removeClass();

                    $(`#${controls?.icons?.contract?.id}`)?.addClass(controls?.icons?.contract?.className);
                    $(`#${controls?.buttons?.contract?.id}`)?.addClass(controls?.buttons?.contract?.className);
                    $(`#${controls?.spinners?.contract?.id}`)?.addClass(controls?.spinners?.contract.className);

                    $(`#${controls?.icons?.back?.id}`)?.addClass(controls?.icons?.back?.className);
                    $(`#${controls?.buttons?.back?.id}`)?.addClass(controls?.buttons?.back?.className);
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(controls?.spinners?.back?.className);
                    break;
                case 1:
                    //$(`#${controls?.buttons?.contract?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    //$(`#${controls?.buttons?.contract?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                    $(`#${controls?.icons?.contract?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.contract?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region old code
            // $(`#${controls?.inputs?.email?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.inputs?.password?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.checkBox?.remenberMe?.id}`).attr('disabled', (processType !== 0));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlRegisterStatus));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion old code

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            $(`#${controls?.dataTables?.elevators?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.elevators?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));

            $(`#${controls?.dataTables?.inventories?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.inventories?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));

            $(`#${controls?.dataTables?.commonAreas?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.commonAreas?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));

            if (processType !== 0) {
                $(`#${controls?.buttons?.contract?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'form - onLoad', });
        //}, [id]) //eslint-disable-line react-hooks/exhaustive-deps
    }, []) //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods (others)

    return (
        <div>
            <Menu viewName='process' process='buildings' />

            <div className='content-wrapper'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{labels?.building?.[languageObj?.id]}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    <li className='breadcrumb-item'><Link to='/'>{labels?.home?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item'><Link to={globalSettings?.app?.backend?.urlBuildings}>{labels?.buildings?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item active'>{labels?.building?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        <div className='row'>
                            <div className='col-12'>

                                {/*building*/}
                                <div className='card card-outline card-primary shadow-lg'>
                                    <LoadingSection alt='loadingSection'
                                        className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.building}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    {/*card header*/}
                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={labels?.buildings?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.buildingsLogo}></img> - {labels?.details?.[languageObj?.id]}
                                        </h6>
                                        <div className='card-tools'>
                                            <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                <i className={icons?.minus}></i>
                                            </button>
                                            {/* <button tooltip='tooltip' title={labels?.contract?.[languageObj?.id]} className='btn btn-outline-success float-right btn-sm' onClick={()=> localElevatorAddGetAsync()}><i className={icons?.plusCircle}></i></button> */}
                                        </div>
                                    </div>

                                    {/*card body*/}
                                    <div className='card-body'>
                                        {/* {building !== null && building !== undefined ? */}
                                        <div>
                                            {/*building data*/}
                                            <div className='row text-muted'>

                                                <div className='col-md-4'>
                                                    <div className='form-group'>
                                                        <div className='row'>
                                                            <div className='col-md-4'>
                                                                <b>{labels?.building?.[languageObj?.id]}</b>:
                                                            </div>
                                                            <div className='col-md-8'>
                                                                {building?.description || ''}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='col-md-4'>
                                                    <div className='form-group'>
                                                        <div className='row'>
                                                            <div className='col-md-4'>
                                                                <b>{labels?.year?.[languageObj?.id]}</b>:
                                                            </div>
                                                            <div className='col-md-8'>
                                                                {building?.year || ''}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='col-md-4'>
                                                    <div className='form-group'>
                                                        <div className='row'>
                                                            <div className='col-md-4'>
                                                                <b>{labels?.email?.[languageObj?.id]}</b>:
                                                            </div>
                                                            <div className='col-md-8'>
                                                                {building?.email || ''}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                            <div className='row text-muted'>
                                                <div className='col-md-4'>
                                                    <div className='form-group'>
                                                        <div className='row'>
                                                            <div className='col-md-4'>
                                                                <b>{labels?.address?.[languageObj?.id]}</b>:
                                                            </div>
                                                            <div className='col-md-8'>
                                                                {building?.address || ''}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='col-md-4'>
                                                    <div className='form-group'>
                                                        <div className='row'>
                                                            <div className='col-md-4'>
                                                                <b>{labels?.contract?.[languageObj?.id]}</b>:
                                                            </div>
                                                            <div className='col-md-8'>
                                                                {/* {!isUndefined(building.contract) && !isNull(building.contractDate) ? building.contract : ''} */}
                                                                {building?.contractId || ''}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='col-md-4'>
                                                    <div className='form-group'>
                                                        {/* <div className='row'>
                                                                <div className='col-md-4'>
                                                                    <b>{labels?.date?.[languageObj?.id]}</b>:
                                                                </div>
                                                                <div className='col-md-8'>
                                                                    {!isUndefined(building.contractDate) && !isNull(building.contractDate) ?
                                                                        dateTimeFormatGlobalSet(building.contractDate, globalSettings?.react?.tempusDominus?.format?.date?.dmy, 12, false).result : ''}
                                                                </div>
                                                            </div> */}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='row text-muted'>
                                                <div className='col-md-4'>
                                                    <div className='form-group'>
                                                        <div className='row'>
                                                            <div className='col-md-4'>
                                                                <b>{labels?.coin?.[languageObj?.id]} ({labels?.base?.[languageObj?.id]})</b>:
                                                            </div>
                                                            <div className='col-md-8'>
                                                                {!isUndNullEmp({ data: building?.coinBaseId, subMethod: 'label - coinBase', })?.result && coins?.length > 0 ?
                                                                    (coins?.filter(({ id, }) => id === building?.coinBaseId)?.[0]?.description || '') : ''}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='col-md-4'>
                                                    <div className='form-group'>
                                                        <div className='row'>
                                                            <div className='col-md-4'>
                                                                <b>{labels?.coin?.[languageObj?.id]} ({labels?.other?.[languageObj?.id]})</b>:
                                                            </div>
                                                            <div className='col-md-8'>
                                                                {!isUndNullEmp({ data: building?.coinOtherId, subMethod: 'label - coinOther', })?.result && coins?.length > 0 ?
                                                                    (coins?.filter(({ id, }) => id === building?.coinOtherId)?.[0]?.description || '') : ''}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='col-md-4'>
                                                    <div className='form-group'>
                                                        <div className='row'>
                                                            <div className='col-md-4'></div>
                                                            <div className='col-md-8'></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        {/* :
                                            <></>} */}
                                    </div> {/*card body*/}

                                    {/*card footer*/}
                                    {/* <div className='card-footer'>

                                    </div> */}

                                </div>{/*card*/}

                                {/*floors / parking stalls*/}
                                <div className='card card-outline card-primary shadow-lg'>
                                    <LoadingSection alt='loadingSection'
                                        className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.floorsParkingStalls}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    {/*card header*/}
                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={labels?.floors?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.handRailsLogo}></img> - {`${labels?.floors?.[languageObj?.id]} / ${labels?.parking}`}
                                        </h6>
                                        <div className='card-tools'>
                                            <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                <i className={icons?.minus}></i>
                                            </button>
                                        </div>
                                    </div>

                                    {/*card body*/}
                                    <div className='card-body'>
                                        {/* {building !== null && building !== undefined ?
                                            <div> */}

                                        {/*top level*/}
                                        <div className='row text-muted'>

                                            <div className='col-md-6 my-center'>
                                                <div className='form-group'>
                                                    <div className='row'>
                                                        <div className='col-md-4'>
                                                            <b>{labels?.topLevel?.[languageObj?.id]}:</b>
                                                        </div>
                                                        <div className='col-md-8'>
                                                            <div className='icheck-primary'>
                                                                <input type='checkbox'
                                                                    id='topLevel'
                                                                    checked={building?.topLevel || false}
                                                                    readOnly />
                                                                <label htmlFor='topLevel'></label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='col-md-6'>
                                                <div className='form-group'>
                                                    <div className='row'>
                                                        <div className='col-md-6'>
                                                            <b>{labels?.apartmentsPerTopLevel?.[languageObj?.id]}:</b>
                                                        </div>
                                                        <div className='col-md-6'>
                                                            {building?.apartmentsPerTopLevel || ''}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                        {/*floors*/}
                                        <div className='row text-muted'>

                                            <div className='col-md-6'>
                                                <div className='form-group'>
                                                    <div className='row'>
                                                        <div className='col-md-4'>
                                                            <b>{labels?.floors?.[languageObj?.id]}:</b>
                                                        </div>
                                                        <div className='col-md-8'>
                                                            {building?.floors || ''}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='col-md-6'>
                                                <div className='form-group'>
                                                    <div className='row'>
                                                        <div className='col-md-6'>
                                                            <b>{labels?.apartmentsPerFloor?.[languageObj?.id]}:</b>
                                                        </div>
                                                        <div className='col-md-6'>
                                                            {!isUndNullEmp({ data: building?.floors, subMethod: 'label - apartmentsPerFloor' })?.result && building?.floors > 0 ?
                                                                (!isUndNullEmp({ data: building?.apartmentsPerFloor, subMethod: 'label - apartmentsPerFloor', })?.result && building?.apartmentsPerFloor > 0 ?
                                                                    building?.apartmentsPerFloor
                                                                    :
                                                                    ''
                                                                )
                                                                :
                                                                ''
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                        {/*low level*/}
                                        <div className='row text-muted'>

                                            <div className='col-md-6 my-center'>
                                                <div className='form-group'>
                                                    <div className='row'>
                                                        <div className='col-md-4'>
                                                            <b>{labels?.lowLevel?.[languageObj?.id]}:</b>
                                                        </div>
                                                        <div className='col-md-8'>
                                                            <div className='icheck-primary'>
                                                                <input type='checkbox'
                                                                    id='lowLevel'
                                                                    checked={building?.lowLevel || false}
                                                                    readOnly />
                                                                <label htmlFor='topLevel'></label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='col-md-6'>
                                                <div className='form-group'>
                                                    <div className='row'>
                                                        <div className='col-md-6'>
                                                            <b>{labels?.apartmentsPerLowLevel?.[languageObj?.id]}:</b>
                                                        </div>
                                                        <div className='col-md-6'>
                                                            {building?.apartmentsPerLowLevel || ''}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                        {/*commands*/}
                                        <div className='row text-muted'>
                                            <div className='col-md-4'>
                                                <div className='form-group'>
                                                    <div className='row'>
                                                        <div className='col-md-8'>
                                                            <b>{labels?.parkingStalls?.[languageObj?.id]}:</b>
                                                        </div>
                                                        <div className='col-md-4'>
                                                            {building?.parkingStalls || ''}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='col-md-4'>
                                                <div className='form-group'>
                                                    <div className='row'>
                                                        <div className='col-md-6'>
                                                            <b>{labels?.totalApartments?.[languageObj?.id]}:</b>
                                                        </div>
                                                        <div className='col-md-6'>
                                                            {totalApartments || ''}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='col-md-4'>
                                                <div className='form-group float-right'>
                                                    <button id={controls?.buttons?.contract?.id}
                                                        className={controls?.buttons?.contract?.className}
                                                        disabled={isUndNullEmp({ data: building?.id, subMethod: 'btn - contract', })?.result}
                                                        hidden={isUndNullEmp({ data: building?.id, subMethod: 'btn - contract', })?.result}
                                                        tooltip='tooltip'
                                                        title={labels?.contract?.[languageObj?.id]}
                                                        type='button'
                                                        onClick={(e) => contractAsync({ e: e, subMethod: 'btn - contracts' })}>
                                                        <i id={controls?.icons?.contract?.id} className={controls?.icons?.contract?.className} /> <span id={controls?.spinners?.contract?.id} className='' aria-hidden='true'></span>
                                                    </button>
                                                    <button id={controls?.buttons?.back?.id}
                                                        className={controls?.buttons?.back?.className}
                                                        //className='btn btn-outline-success mx-1'
                                                        tooltip='tooltip'
                                                        title={labels?.back?.[languageObj?.id]}
                                                        type='button'
                                                        onClick={(e) => backToGoAsync({ e: e, subMethod: 'btn - back', })}>
                                                        <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        {/* </div> 
                                            :
                                            <></>} */}
                                    </div> {/*card body*/}

                                    {/*card footer*/}
                                    {/* <div className='card-footer'>

                                    </div> */}

                                </div>{/*card*/}

                                {/* {!showLoading ?
                                    <div>
                                        {showData ?
                                <div>*/}
                                {/*elevators*/}
                                <div className='card card-outline card-primary shadow-lg'>
                                    <LoadingSection alt='loadingSection'
                                        className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.elevators}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    {/*card header*/}
                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={labels?.elevators?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.elevatorsLogo}></img> - {labels?.elevators?.[languageObj?.id]}
                                        </h6>
                                        <div className='card-tools'>
                                            <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                <i className={icons?.minus}></i>
                                            </button>
                                        </div>
                                    </div>

                                    {/*card body*/}
                                    <div className='card-body'>

                                        {building !== null && building !== undefined ?
                                            <div>

                                                {/*elevators*/}
                                                <div className='row'>
                                                    <div className='col-md-12'>
                                                        <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                                            <table id={dtElevatorsId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div> :
                                            <></>}

                                    </div> {/*card body*/}

                                    {/*card footer*/}
                                    {/* <div className='card-footer'></div> */}

                                </div>{/*card*/}

                                {/*inventory*/}
                                <div className='card card-outline card-primary shadow-lg'>
                                    <LoadingSection alt='loadingSection'
                                        className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.inventory}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    {/*card header*/}
                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={labels?.inventory?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.inventoriesLogo}></img> - {labels?.inventory?.[languageObj?.id]}
                                        </h6>
                                        <div className='card-tools'>
                                            <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                <i className={icons?.minus}></i>
                                            </button>
                                        </div>
                                    </div>

                                    {/*card body*/}
                                    <div className='card-body'>

                                        {building !== null && building !== undefined ?
                                            <div>

                                                {/*inventory*/}
                                                <div className='row'>
                                                    <div className='col-md-12'>
                                                        <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                                            <table id={dtInventoriesId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div> :
                                            <></>}

                                    </div> {/*card body*/}

                                    {/*card footer*/}
                                    {/* <div className='card-footer'></div> */}

                                </div>{/*card*/}

                                {/*Common areas*/}
                                <div className='card card-outline card-primary shadow-lg'>
                                    <LoadingSection alt='loadingSection'
                                        className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.commonArea}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    {/*card header*/}
                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={labels?.commonAreas?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.partyFlags}></img> - {labels?.commonAreas?.[languageObj?.id]}
                                        </h6>
                                        <div className='card-tools'>
                                            <button type='button'
                                                className='btn btn-tool'
                                                data-card-widget='collapse'>
                                                <i className={icons?.minus}></i>
                                            </button>
                                        </div>
                                    </div>

                                    {/*card body*/}
                                    <div className='card-body'>

                                        {building !== null && building !== undefined ?
                                            <div>

                                                {/*Common area*/}
                                                <div className='row'>
                                                    <div className='col-md-12'>
                                                        <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                                            <table id={dtCommonAreasId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div> :
                                            <></>}

                                    </div> {/*card body*/}

                                    {/*card footer*/}
                                    {/* <div className='card-footer'></div> */}

                                </div>{/*card*/}
                                {/* </div> */}
                                {/* :
                                            <div></div>
                                        }
                                    </div>
                                    :
                                    <div> */}
                                {/* <CssfxLoading type={globalSettings?.react?.CssfxLoading?.circularProgress}
                                            width={40}
                                            height={40}
                                            color={globalSettings?.colors?.infoColorExp}
                                            msgText={messages?.processing?.[languageObj?.id]}
                                            msgOrientation='text-center'
                                            msgTextMuted={true} /> */}
                                {/* </div>
                                } */}
                            </div>{/*col*/}
                        </div>{/*row*/}

                    </div>{/* /.container-fluid */}
                </section>
                {/* /.content */}

            </div>

            {showModalElevator ?
                <ElevatorAddEditDetails $={$}
                    showModal={showModalElevator}
                    setShowModal={setShowModalElevator}
                    building={building}
                    buildingTwo={buildingTwo}
                    elevator={elevator}
                    setElevator={setElevator}
                    elevatorGetType={elevatorGetType}
                    processValues={processValues}
                    languageObj={languageObj} />
                :
                <></>
            }

            {showModalInventory ?
                <InventoryAddEditDetails $={$}
                    showModal={showModalInventory}
                    setShowModal={setShowModalInventory}
                    building={building}
                    buildingTwo={buildingTwo}
                    inventory={inventory}
                    setInventory={setInventory}
                    processValues={processValues}
                    languageObj={languageObj} />
                :
                <></>
            }

            {commonAreaShowModal ?
                <CommonAreaAddEditDetails $={$}
                    processValues={processValues}
                    building={building}
                    buildingTwo={buildingTwo}
                    commonArea={commonArea}
                    setCommonArea={setCommonArea}
                    languageObj={languageObj} />
                :
                <></>
            }

            {contractShowModal ?
                <BuildingContracts $={$}
                    auth={auth}
                    dtId={contractsDtId}
                    rowIndex={0}
                    showModal={contractShowModal}
                    setShowModal={setContractShowModal}
                    type={(userRole === globalSettings?.roles?.master || userRole === globalSettings?.roles?.admin ? 0 : 2)}
                    building={building}
                    contracts={contracts}
                    setContracts={setContracts}
                    contractsDt={contractsDt}
                    setContractsDt={setContractsDt}
                    languageObj={languageObj} />
                :
                <></>
            }
        </div>
    )
}